import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Button, Typography } from '@mui/joy';
import { WarningRounded } from '@mui-symbols-material/w200';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import _ from 'lodash';
import ImportAssetApprovalModal from '../ImportAssetApprovalModal';
import { AssetLocationImportWidget as AssetLocationImportWidgetQuery } from '../../graphql/queries/assetLocationImportWidget';

interface Props {
    assetLocationId: string;
}

const AssetLocationImportWidget = ({ assetLocationId }: Props) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    const { data, loading, error } = useQuery(AssetLocationImportWidgetQuery, {
        variables: { id: assetLocationId }
    });

    const assetLocationImport = _.get(data, 'assetLocation.asset.assetLocationImport');
    const status = _.get(assetLocationImport, 'status');
    const insertDate = _.get(assetLocationImport, 'insert');

    if (loading || error || !assetLocationImport || status !== 'OPEN') {
        return null;
    }

    const formattedDate = moment(insertDate).format('DD.MM.YY HH:mm');

    return (
        <>
            <Box sx={{ display: 'flex', borderRadius: '5px', backgroundColor: '#FFDC99', px: '21px', py: '13px', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', gap: '13px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <WarningRounded sx={{ width: 42, height: 42 }} />
                    <Box>
                        <Typography level="titleMedium">
                            {t('Asset from import')}
                        </Typography>
                        <Typography level="titleMediumLight">
                            {t('The asset was imported on {{date}} but has not been approved yet.', { date: formattedDate })}
                        </Typography>
                    </Box>
                </Box>
                <Button
                    color="primary"
                    onClick={() => setModalOpen(true)}
                    sx={{ display: 'flex', gap: '6px', px: '16px', py: '10px' }}
                >
                    <Typography level="bodyBold">
                        {t('Approve')}
                    </Typography>
                </Button>
            </Box>

            {modalOpen && (
                <ImportAssetApprovalModal
                    assetLocationId={assetLocationId}
                    open={modalOpen}
                    allAssetLocationIds={[assetLocationId]}
                    onClose={() => setModalOpen(false)}
                    onAssetChange={() => {}}
                />
            )}
        </>
    );
};

export default AssetLocationImportWidget;
